import { GridError } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const GridErrorSocieteEspaceFamilleActions = createActionGroup({
  source: 'Grid Error Societe Espace Famille',
  events: {
    'Add One Grid Error Societe Espace Famille': props<{
      gridErrorSocieteEspaceFamille: GridError;
    }>(),
    'Delete One Grid Error Societe Espace Famille Success': props<{ idGridError: number }>()
  }
});
